(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "689d2e28ff240ea30c074d62";
              window.beaePageSetting.pageTitle = "Footer Section"; 
              window.beaePageSetting.pageType = "footer";

          let js_EQTE1FBG = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-b1wz9fq8section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-b1wz9fq8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-b1wz9fq8');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-b1wz9fq8: ', ex)
      };
    

      try {
        let argid = 'beae-4mam3bh3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4mam3bh3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4mam3bh3');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4mam3bh3: ', ex)
      };
    

      try {
        let argid = 'beae-0qurxrw7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0qurxrw7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0qurxrw7');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0qurxrw7: ', ex)
      };
    

      try {
        let argid = 'beae-z8vq74kxlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-z8vq74kx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-z8vq74kx');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-z8vq74kx: ', ex)
      };
    

      try {
        let argid = 'beae-dp5qy1gublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-dp5qy1gu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-dp5qy1gu');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-dp5qy1gu: ', ex)
      };
    

      try {
        let argid = 'beae-x4fybkbdblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x4fybkbd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x4fybkbd');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x4fybkbd: ', ex)
      };
    

      try {
        let argid = 'beae-2e8kdm86block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2e8kdm86',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2e8kdm86');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2e8kdm86: ', ex)
      };
    

      try {
        let argid = 'beae-2jkuug7zblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2jkuug7z',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2jkuug7z');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2jkuug7z: ', ex)
      };
    

      try {
        let argid = 'beae-0qksf8tqlc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0qksf8tq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0qksf8tq');
        args.el = args.els[0];
        ((m) => { let h=m.checkLive;function p(_){return{input:_.querySelector('input[name="locale_code"], input[name="country_code"]'),button:_.querySelector("button.beae-current-value"),panel:_.querySelector(".beae-language-results"),search:_.querySelector('input[name="language_filter"]'),resetButton:_.querySelector(".beae-reset-button")}}function f(_,M){const V=m.el.querySelector("form.beae-localization");M.input.value=_.currentTarget.dataset.value,V&&V.submit()}function b(_){_.button.focus(),_.panel.classList.toggle("hidden-dropdown"),_.button.setAttribute("aria-expanded",(_.button.getAttribute("aria-expanded")==="false").toString());const M=_.button.getBoundingClientRect();window.innerHeight-M.bottom<_.panel.offsetHeight?(_.panel.style.top="auto",_.panel.style.bottom="100%"):(_.panel.style.top="100%",_.panel.style.bottom="auto")}function k(_){return _.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function g(_,M){const V=k(M.search.value),L=_.querySelectorAll(".beae-languages li");L.length,M.resetButton.classList.toggle("hidden",!V),L.forEach(T=>{k(T.querySelector(".beae-language-name").textContent).indexOf(V)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function v(_){_.code.toUpperCase()==="ENTER"&&_.preventDefault()}function S(_,M,V){_.stopPropagation(),V.search.value="",g(M,V)}function B(_,M,V){(!M.contains(_.target)||!M.contains(_.relatedTarget))&&(C(M,V),V.button.setAttribute("aria-expanded",(V.button.getAttribute("aria-expanded")==="false").toString()))}function C(_,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",g(_,M))}function $(_){const M=p(_);h&&_.addEventListener("focusout",V=>B(V,_,M)),M.button.addEventListener("click",()=>b(M)),_.querySelectorAll(".beae-language-name").forEach(V=>V.addEventListener("click",L=>f(L,M))),M.search&&(M.search.addEventListener("keyup",()=>g(_,M)),M.search.addEventListener("keydown",v)),M.resetButton&&(M.resetButton.addEventListener("click",V=>S(V,_,M)),M.resetButton.addEventListener("mousedown",V=>V.preventDefault()))}m.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0qksf8tq: ', ex)
      };
    

      try {
        let argid = 'beae-wclnrtzablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wclnrtza',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wclnrtza');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wclnrtza: ', ex)
      };
    

      try {
        let argid = 'beae-zwoakx4nblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zwoakx4n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zwoakx4n');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zwoakx4n: ', ex)
      };
    

      try {
        let argid = 'beae-9c0d0666section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9c0d0666',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9c0d0666');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9c0d0666: ', ex)
      };
    

      try {
        let argid = 'beae-um851iq7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-um851iq7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-um851iq7');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-um851iq7: ', ex)
      };
    

      try {
        let argid = 'beae-puvrf1rjblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-puvrf1rj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-puvrf1rj');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(A){let D=0,Z;q(),z?H.onmouseover=function(U){W(U)}:A.onmousedown=function(U){W(U)},H.onmouseup=function(){j()},A.ontouchstart=function(U){W(U)},H.ontouchend=function(){j()};function q(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function W(U){check=!1,U.preventDefault(),U.clientX?U.clientX:U.touches[0].clientX,parseInt(A.style.left),D=1,H.onmousemove=function(K){R(K)},H.ontouchmove=function(K){R(K)}}function j(){D=0,check=!0}function R(U){if(D==0)return!1;Z=G(U),Z<0&&(Z=0),Z>100&&(Z=100),F(Z)}function G(U){const K=H.getBoundingClientRect(),oe=(U.changedTouches?U.changedTouches[0].clientX:U.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(oe*100/I)))}function F(U){A.style.left=U+"%",T.style.clipPath=`polygon(${U}% 0%, ${U}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${U}% 0%, ${U}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-puvrf1rj: ', ex)
      };
    }; if (window.BEAEBASE) {js_EQTE1FBG()} else {window.BEAEPAGEJS.push(js_EQTE1FBG)} })(); 